import { useMutation } from "@tanstack/react-query";
import { getExercise } from "../queries/exercises";
import { useExercisePageStore } from "../stores/exercisesPageStore";

export const useGetNextExercise = () => {
  const { setNextExercise } = useExercisePageStore();

  const { mutateAsync } = useMutation({
    mutationKey: ['get-next-exercise'],
    mutationFn: (slug: string) => getExercise(slug),
    onSuccess: (data) => {
      if(data) {
        setNextExercise(data);
      }
    }
  })

  return { getNextQuestion: mutateAsync};
}